import { redirect } from 'react-router-dom';
import type { ActionFunctionArgs } from 'react-router-dom';
import { AuthenticationError } from 'src/types/errors';
import { logout } from 'src/utils/auth_utils';

/**
 * Wraps a route action so that if an AuthenticationError is thrown (e.g. from
 * a 401 API response), the user is logged out and redirected to /login.
 * Use for all route actions that call the API.
 */
export function withAuthAction<T>(
  handler: (args: ActionFunctionArgs) => Promise<T>,
): (args: ActionFunctionArgs) => Promise<T> {
  return async (args: ActionFunctionArgs): Promise<T> => {
    try {
      return await handler(args);
    } catch (error) {
      if (error instanceof AuthenticationError) {
        await logout();
        throw redirect('/login');
      }
      throw error;
    }
  };
}
